<!--
  ExcessAlert — Warning banner for pending transaction excesses on supplier dashboard.

  Related issues:
  - https://github.com/MangoTec/mango-api/issues/78 [CDC-015] Banner de excedentes pendientes

  Spec ref: §6.6.5
-->
<template>
  <v-alert
    v-if="hasExcesses"
    type="warning"
    prominent
    border="left"
    colored-border
    elevation="2"
    class="mb-6"
  >
    <v-row align="center" no-gutters>
      <v-col cols="12" md="8">
        <div class="text-subtitle-1 font-weight-bold">
          Tienes {{ excessCount }} excedente{{ excessCount > 1 ? "s" : "" }}
          pendiente{{ excessCount > 1 ? "s" : "" }}
        </div>
        <div class="text-body-2 mt-1">
          Monto total: {{ totalAmount | currency }}
        </div>
      </v-col>
      <v-col cols="12" md="4" class="text-md-right mt-2 mt-md-0">
        <v-btn color="warning" outlined @click="goToExcesses">
          Ver excedentes
          <v-icon right>mdi-arrow-right</v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </v-alert>
</template>

<script>
import ExcessService from "@/services/excessService";
import SentryService from "@/services/sentryService";

export default {
  name: "ExcessAlert",

  data: () => ({
    excessCount: 0,
    totalAmount: 0,
    loading: false,
  }),

  computed: {
    hasExcesses() {
      return this.excessCount > 0;
    },
  },

  async mounted() {
    await this.fetchPendingExcesses();
  },

  methods: {
    async fetchPendingExcesses() {
      this.loading = true;
      try {
        const supplierId = this.$UserManager.getOwnerId();
        const response = await ExcessService.getSummary(supplierId);

        if (response && response.ok) {
          const result = await response.json();

          if (result.success && result.data) {
            this.excessCount = result.data.pending_count || 0;
            this.totalAmount = result.data.pending_amount || 0;
          }
        }
      } catch (error) {
        SentryService.captureError(error, {
          action: "ExcessAlert.fetchPendingExcesses",
          supplierId: this.$UserManager.getOwnerId(),
        });
      } finally {
        this.loading = false;
      }
    },

    goToExcesses() {
      this.$router.push({ name: "excesses" });
    },
  },

  filters: {
    currency(value) {
      var formatter = new Intl.NumberFormat("es-MX", {
        style: "currency",
        currency: "MXN",
      });

      return formatter.format(value);
    },
  },
};
</script>
